export const cookieTypes = {
  userEmail: "userRoleId",
  sessionId: "userUuid",
};

export default class {
  static setCookie(cookieName: string, cookieValue: string, duration: number) {
    const d = new Date();
    d.setTime(d.getTime() + duration * 24 * 60 * 60 * 1000);
    document.cookie = `${cookieName}=${cookieValue};expires=${d.toUTCString()};path=/`;
  }

  static getCookie(name: string) {
    if (document.cookie !== "") {
      const cookies = document.cookie.split(/; */);

      for (let i = 0; i < cookies.length; i++) {
        const cookieName = cookies[i].split("=")[0];
        const cookieVal = cookies[i].split("=")[1];

        if (cookieName === decodeURIComponent(name)) {
          return decodeURIComponent(cookieVal);
        }
      }
    }

    return "";
  }

  static deleteCookie(name: string) {
    const cookieName = encodeURIComponent(name);

    document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/`;
  }

  static replaceEqual(value: string) {
    const regEx = new RegExp("=", "g");
    value = value.replace(regEx, "&equal");
    return value;
  }

  static revertEqual(value: string) {
    const regEx = new RegExp("&equal", "g");
    value = value.replace(regEx, "=");
    return value;
  }
}
